import classNames from "classnames";
import styles from "./index.module.scss";
import { Row, Col } from "antd";
import intl from "react-intl-universal";
import { useEffect, useState } from "react";
// import icon1 from "@/assets/images/about/icon1.svg"
import icon2 from "@/assets/images/about/icon2.svg"
import icon3 from "@/assets/images/about/icon3.svg"
import icon4 from "@/assets/images/about/icon4.svg"
import SvgText from './svgText';
import { communityData } from "@/apis/public";
const Statistics = () => {
	const [data, setData] = useState({})
	const list = [
		// {
		// 	svgPath: icon1,
		// 	total: "15",
		// 	des: ["OGE Alliance", "Members1"]
		// },
		{
			svgPath: icon2,
			total: data.resourceContributorCount ? data.resourceContributorCount : "0",
			des: ["Open Resource", "Contributors"]
		},
		{
			svgPath: icon3,
			total: data.availableResourceCount ? data.availableResourceCount : "0",

			des: ["Open Resource", "Avaliable"]
		},
		{
			svgPath: icon4,
			total: data.communityMemberCount ? data.communityMemberCount : "0",
			des: ["OGE Alliance community", "Members2"]
		}
	]
	const colorMap = {
		0: ["#4978BA", "#50859B"],
		1: ["#50859B", "#579085"],
		2: ["#579085", "#5F9C6C"],
		3: ["#5F9C6C", "#50A74E"],
	}
	useEffect(() => {
		communityData().then(res => {
			setData(res.data)
		})
	}, [])


	return (
		<div className="container" style={{ marginTop: "60px" }} >
			{/* <div className={styles.titleBox}>
				{intl.get("About.stDes")}
			</div> */}
			<Row>
				{list.map((item, index) => {
					return <Col key={index + "_statistics"} span={8}>
						<div className={styles.colBox}>
							<div className={classNames("flex_box", "align_center", "flex_center", styles.imgBox)}>
								<img src={item.svgPath} />
							</div>
							<SvgText color1={colorMap[index][0]} index={index} color2={colorMap[index][1]} text={item.total} />
							{/* <h2>{item.total}</h2> */}
							<div className={styles.textBox}>
								{item.des.map((son, son_index) => {
									return <div key={son_index + '_des_' + "index"}>{intl.get(`About.${son}`)}</div>
								})}
							</div>
						</div>
					</Col>
				})}
			</Row>
		</div>
	)
}
export default Statistics